// Resets Photo Edits

import PhotoModifications from '../common/photo-modifications';

export default function resetPhotoEdits(photo) {
  new PhotoModifications(photo).reset('gamma', 'straighten', 'angle', 'colour_fx', 'fx', 'crop');

  return photo;
}
